import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { createEqFilter, createEqFilterInCollection } from './odata-helper';
import * as GeneratedObjectType from '../types/generated-objectType.type';
import buildQuery from 'odata-query';
import { IserverService } from './iserver.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ObjectTypeService {
  constructor(private iserverService: IserverService) {}

  getObjectTypeId(objectTypeName: string): Observable<string> {
    const filter = createEqFilter(
      GeneratedObjectType.ATTR_NAME,
      objectTypeName
    );
    const select = [GeneratedObjectType.ATTR_OBJECTTYPEID.name];
    const query = buildQuery({ filter, select });
    const url = `${environment.iServerUrl}/odata/ObjectTypes${query}`;
    return this.iserverService
      .query(url)
      .pipe(map((res) => res['value'][0]['ObjectTypeId']));
  }

  getObjectTypes(): Observable<GeneratedObjectType.Gen_ObjectType[]> {
    const filter = createEqFilterInCollection(
      'Solutions',
      'SolutionId',
      environment.iServerDrxSolutionId,
      'Edm.Guid'
    );

    const query = buildQuery({ filter });
    const url = `${environment.iServerUrl}/odata/ObjectTypes${query}`;
    return this.iserverService.query(url).pipe(map((res) => res['value']));
  }
}
